import { render, staticRenderFns } from "./TypeDescription.vue?vue&type=template&id=01195daa&"
import script from "./TypeDescription.vue?vue&type=script&lang=js&"
export * from "./TypeDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports